export default {"src":"/_next/static/media/GridSelectionSeparator.60e140bd.svg","height":41,"width":1,"blurWidth":0,"blurHeight":0};